import React, { FC, useState } from 'react';
import { Button, Card, message, UploadFile } from 'antd';
import { uploadAudioFile } from '../../api/speechToInsightsApi';
import { ListeningTypeSelector } from '../ListeningTypeSelector/ListeningTypeSelector';
import { FileUploader } from '../FileUploader/FileUploader';

interface AudioFileTabProps {
    setIsProcessing: (value: boolean) => void;
    isProcessing: boolean;
}

export const AudioFileTab: FC<AudioFileTabProps> = ({ setIsProcessing, isProcessing }) => {
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [listeningType, setListeningType] = useState('');

    const handleListeningTypeChange = (value: string) => {
        setListeningType(value);
    };

    const handleStartProcessing = async () => {
        if (fileList.length === 0) {
            message.error('Por favor, adjunta un archivo MP3');
            return;
        }

        const file = fileList[0].originFileObj;
        if (!file) {
            message.error('No se pudo acceder al archivo');
            return;
        }

        if (!listeningType) {
            message.error('Por favor, selecciona un tipo de análisis');
            return;
        }

        setIsProcessing(true);

        try {
            await uploadAudioFile(file, listeningType);
            message.success('Proceso iniciado correctamente');
        } catch (error) {
            message.error('Error al procesar el archivo de audio');
        } finally {
            setIsProcessing(false);
        }
    };

    return (
        <Card>
            <ListeningTypeSelector
                value={listeningType}
                onChange={handleListeningTypeChange}
                disabled={isProcessing}
            />
            <FileUploader
                accept=".mp3"
                fileList={fileList}
                onChange={setFileList}
                disabled={isProcessing}
                uploadText="Haz clic o arrastra un archivo .mp3 aquí para subir"
            />
            <Button
                type="primary"
                onClick={handleStartProcessing}
                disabled={fileList.length === 0}
                style={{ marginTop: '16px' }}
                block
                loading={isProcessing}
            >
                Iniciar Proceso
            </Button>
        </Card>
    );
};